import { Media } from '../media/Media'
import { Artwork } from '../artwork/Artwork'
import { ArtistStatus } from './ArtistStatus'

export class Artist {
  id?: string | number = undefined
  name?: string = undefined
  slug?: string = undefined
  about?: string = undefined
  absenceUntil?: string = undefined
  hasCV?: boolean = false
  media?: Media = {}
  artworks?: Artwork[] = []
  posts?: any[] = []
  video?: string = undefined
  isVisible?: boolean = undefined
  status?: ArtistStatus
  my_subscription_id?: string
  is_merchandise?: boolean

  constructor (data: Partial<Artist> = {}) {
    Object.assign(this, data)
  }


  getArtistMedia() {
    return {
      url: this.media ? this.media.url : "/static/img/user.png",
      color: this.media ? this.media.color : "",
      srcset: this.media ? this.media.srcset : ""
    };
  }

}
